import type { PageHelp } from '../network-help.data';

export const L10N_ru_g2: Record<string, PageHelp> = {
  'agency-onboarding': {
    title: 'Подключение агентства',
    tag: 'Мастер',
    tagline: 'Ввод нового туристического бизнеса в сеть с соблюдением требований.',
    business: {
      lead: 'Подключение — это контролируемый вход в сеть. Прежде чем новое агентство сможет двигать деньги или выписывать билеты, платформа должна узнать, кто они, проверить их и согласовать коммерческие условия — именно здесь создаётся эта связь.',
      points: [
        { title: 'Соответствие до начала торговли', desc: 'Проверки личности и финансов (KYC) происходят заранее, потому что платформа предоставляет кредит и расчёты новому контрагенту.' },
        { title: 'Условия определяют отношения', desc: 'Уровень, профиль наценки и доступ к продуктам согласуются здесь — они определяют, как агентство торгует с первого дня.' },
        { title: 'Быстрый путь к первой продаже', desc: 'Чистое подключение выводит приносящего доход партнёра в работу в рамках SLA подключения.' },
      ],
    },
    software: {
      lead: 'Пошаговая направляющая форма, которая собирает запись агентства и направляет её на утверждение.',
      points: [
        { title: 'Пройдите запись по шагам', desc: 'Компания → контакты → документы KYC → финансовая настройка → продукты и доступ → уровень и наценка → проверка.' },
        { title: 'Отправка в очередь', desc: 'Завершение мастера подаёт заявку в очередь проверки KYC, а не выводит её сразу в работу.' },
        { title: 'Всё в одном месте', desc: 'Контакты, документы и коммерческие условия фиксируются вместе, чтобы у проверяющих была полная картина.' },
      ],
    },
    related: ['agency-kyc', 'contract-templates', 'agencies'],
  },

  'agency-kyc': {
    title: 'Очередь проверки KYC',
    tag: 'Комплаенс',
    tagline: 'Барьер, который проходит каждое новое агентство перед началом торговли.',
    business: {
      lead: 'KYC — «Знай своего клиента» — это обязанность проверить личность бизнеса, прежде чем позволить ему работать с деньгами на платформе. Эта очередь — контрольная точка, которая защищает сеть от мошенничества и риска безнадёжных долгов.',
      points: [
        { title: 'Требование, а не формальность', desc: 'Платформа обязана проверять контрагентов, прежде чем предоставлять кошельки или кредит.' },
        { title: 'Риск, сделанный видимым', desc: 'Каждая заявка несёт сигнал риска, чтобы проверяющие тратили время там, где риск наиболее высок.' },
        { title: 'SLA — это обещание', desc: 'Быстрая обработка заявок сохраняет скорость подключения без пропуска проверки.' },
      ],
    },
    software: {
      lead: 'Сортировочная очередь ожидающих заявок, каждая со своим конвейером документов для утверждения или отклонения.',
      points: [
        { title: 'Работайте с очередью', desc: 'Список заявок с их этапом; откройте одну, чтобы просмотреть поданные документы.' },
        { title: 'Следуйте по конвейеру', desc: 'Поэтапное представление прогресса показывает, где находится каждая заявка и что осталось до решения.' },
        { title: 'Примите решение', desc: 'Утвердите, чтобы вывести агентство в живую торговлю (с автоматической генерацией его мастер-соглашения), или отклоните с указанием причины.' },
      ],
    },
    related: ['agency-onboarding', 'contract-templates', 'agencies'],
  },

  'agency-profile': {
    title: 'Профиль агентства',
    tag: 'Запись',
    tagline: 'Полные коммерческие и комплаенс-отношения одного агентства.',
    business: {
      lead: 'Профиль — это полная картина одних торговых отношений: их положение, их деньги и условия, на которых они работают. Это то, что вы открываете, чтобы понять или скорректировать, как конкретное агентство ведёт дела с платформой.',
      points: [
        { title: 'Условия живут здесь', desc: 'Уровень, наследование наценки и доступ к продуктам определяют экономику этого агентства и управляются в этой записи.' },
        { title: 'Положение с первого взгляда', desc: 'Кошелёк, кредит и статус KYC мгновенно сообщают, может ли агентство торговать прямо сейчас.' },
        { title: 'Наследовать или переопределить', desc: 'Агентство может следовать значениям по умолчанию своего уровня или нести индивидуальные переопределения, согласованные именно для него.' },
      ],
    },
    software: {
      lead: 'Детальная поверхность по каждому агентству, сводящая личность, деньги и конфигурацию в один вид.',
      points: [
        { title: 'Управление активами и доступом', desc: 'SIGN, каналы продаж, филиалы, роли и доступ к продуктам для этого агентства доступны отсюда.' },
        { title: 'Членство в группах', desc: 'Членства агентства в ценовых группах показаны в виде полосы чипов и питают правила уровня Группы.' },
        { title: 'Свой вид против админского', desc: 'Агентство видит свой профиль преимущественно на чтение; администратор может редактировать условия и совершать действия.' },
      ],
    },
    related: ['agencies', 'markup', 'branches', 'signs'],
  },

  'contract-templates': {
    title: 'Шаблоны договоров',
    tag: 'Соглашения',
    tagline: 'Шаблоны условий, из которых генерируется мастер-соглашение.',
    business: {
      lead: 'Каждое агентство торгует по мастер-соглашению. Шаблоны договоров — это версионированные условия, из которых эти соглашения генерируются, чтобы юридические отношения были согласованными, актуальными и поддающимися аудиту во всей сети.',
      points: [
        { title: 'Единый источник условий', desc: 'Генерация договора агентства берёт данные из этого каталога, так что все подписывают одни и те же актуальные условия.' },
        { title: 'Версионированность и аудит', desc: 'Новые версии заменяют старые; выведенные из обращения версии остаются доступны для продления более старых договоров.' },
        { title: 'Питает жизненный цикл', desc: 'Шаблон — это вход в поток соглашения генерация → отправка → подписание → встречное подписание → активно.' },
      ],
    },
    software: {
      lead: 'Каталог версий шаблонов, который читает форма генерации.',
      points: [
        { title: 'Добавить версию', desc: 'Создайте новую версию шаблона и загрузите её исходный документ.' },
        { title: 'Выводите из обращения, не удаляйте', desc: 'Выводите из обращения замещённые версии; они остаются разрешимыми для договоров, уже на них основанных.' },
        { title: 'Источник для выбора', desc: 'Средство выбора шаблона в форме генерации договора читает этот каталог.' },
      ],
    },
    related: ['agency-onboarding', 'agency-kyc', 'agencies'],
  },

  'reference-data': {
    title: 'Справочные данные',
    tag: 'Основные словари',
    tagline: 'Канонические списки поиска, из которых строятся каждое бронирование, ваучер и цена.',
    business: {
      lead: 'Справочные данные — это общий источник истины: авиакомпании, аэропорты, города, валюты, типы номеров, классы обслуживания и десятки других. Однократная нормализация означает, что результаты поиска, билеты, ваучеры и правила ценообразования говорят на одном языке между поставщиками и сервисами.',
      points: [
        { title: 'Согласованность по всей платформе', desc: 'Один выверенный список питает каждый сервис, так что коды поставщика повсюду сопоставляются с одной и той же канонической записью.' },
        { title: 'Изменить один раз — применить везде', desc: 'Редактирование справочной строки обновляет её для поиска, бронирования, документов и отчётности сразу.' },
        { title: 'Управляемое, а не свободный текст', desc: 'Контролируемые словари не пускают грязные данные в ценообразование и сопоставление каналов.' },
      ],
    },
    software: {
      lead: 'Административная поверхность на основе схемы над ~35 категориями справочников, сгруппированными по домену.',
      points: [
        { title: 'Просмотр и редактирование по категории', desc: 'Выберите категорию, ищите её строки и добавляйте / редактируйте / активируйте-деактивируйте записи; некоторые датированы по сроку действия (валюты, налоги, курсы).' },
        { title: 'Тонкий доступ', desc: 'Просмотр / Добавление / Редактирование / Статус предоставляются по категории через «Роли и доступ» — кнопки здесь отражают то, что позволяет ваша роль.' },
        { title: 'Каноническое против редактируемого', desc: 'Некоторые списки (страны, часовые пояса) являются каноническими и управляются централизованно, а не создаются произвольно.' },
      ],
    },
    related: ['rbac', 'data-simulator'],
  },

  'data-simulator': {
    title: 'Симулятор данных',
    tag: 'Синтетические данные',
    tagline: 'Генерируйте реалистичные бронирования, чтобы прогонять платформу без реальных заказов.',
    business: {
      lead: 'Симулятор производит правдоподобный спрос — бронирования по продуктам, агентствам и датам — чтобы дашборды, отчёты, ценообразование и расчёты можно было продемонстрировать и нагрузочно протестировать до или параллельно с реальной торговлей.',
      points: [
        { title: 'Докажите платформу', desc: 'Наполненная система показывает заинтересованным сторонам, как ведут себя отчётность и денежные потоки на объёме.' },
        { title: 'Безопасно отменить', desc: 'Сгенерированные заказы помечены, так что целую партию можно чисто откатить.' },
        { title: 'Целевые сценарии', desc: 'Нацельте партию на конкретные агентства или продукты, чтобы смоделировать определённый срез бизнеса.' },
      ],
    },
    software: {
      lead: 'Пакетный генератор, который вбрасывает реальные помеченные заказы в движок бронирований.',
      points: [
        { title: 'Настройте партию', desc: 'Выберите объём, микс продуктов, агентства и диапазон дат, затем опубликуйте.' },
        { title: 'Реальные заказы, помеченные', desc: 'Опубликованные элементы — это настоящие заказы booking-service, помеченные «simulated», так что они появляются во «Всех бронированиях».' },
        { title: 'Откат всей партии', desc: 'Удалите партию одним действием, чтобы вернуть систему в прежнее состояние.' },
      ],
    },
    related: ['reference-data', 'rbac'],
  },

  rbac: {
    title: 'Роли и доступ',
    tag: 'RBAC',
    tagline: 'Собирайте тонко детализированные разрешения в роли, которые несут ваши люди.',
    business: {
      lead: 'Доступ управляется разрешениями, а не должностями. «Роли и доступ» — это место, где вы собираете атомарные коды разрешений в роли и выдаёте их, чтобы каждый человек мог делать ровно то, что должен, и ничего больше — будь то сотрудник платформы или пользователь агентства.',
      points: [
        { title: 'Наименьшие привилегии', desc: 'Выдача узких разрешений ограничивает радиус поражения, если аккаунт используется неправильно.' },
        { title: 'Два уровня', desc: 'Роли платформы действуют по всей сети; роли агентства ограничены их собственным арендатором.' },
        { title: 'Защита от блокировки', desc: 'Запечатанные системные роли (например, Администратор платформы) держат свои разрешения заблокированными, так что никто не может лишить себя доступа.' },
      ],
    },
    software: {
      lead: 'Роли, пользователи и живой каталог разрешений в одном месте.',
      points: [
        { title: 'Создайте роль', desc: 'Отметьте коды разрешений, сгруппированные по модулю; роль — это просто набор, который вы выбираете.' },
        { title: 'Матрица справочных данных', desc: 'Разрешения на справочные данные выдаются по категория × действие (Просмотр/Добавление/Редактирование/Статус); роли агентства получают только Просмотр.' },
        { title: 'Назначьте пользователям', desc: 'Вкладка «Пользователи» прикрепляет роли к людям, ограниченные платформой или конкретным агентством.' },
      ],
    },
    related: ['users', 'reference-data', 'settings'],
  },

  users: {
    title: 'Пользователи',
    tag: 'Учётные записи',
    tagline: 'Люди, которые могут входить в систему, и роли, которые они несут.',
    business: {
      lead: 'Пользователи — это лица, работающие с платформой: сотрудники платформы и сотрудники агентств. Управление ими здесь — это способ контролировать, у кого есть доступ, поддерживать его актуальным по мере прихода и ухода людей и привязывать каждое действие к ответственной учётной записи.',
      points: [
        { title: 'Доступ следует за трудоустройством', desc: 'Своевременное создание и деактивация учётных записей — это передний край безопасности.' },
        { title: 'Роли несут полномочия', desc: 'Пользователь сам по себе ничего не делает — его роли решают, что он может делать.' },
        { title: 'Подотчётность', desc: 'Действия относимы к именованной учётной записи, что важно для аудита и споров.' },
      ],
    },
    software: {
      lead: 'Каталог учётных записей с их ролями и статусом.',
      points: [
        { title: 'Создание и назначение', desc: 'Создайте пользователя и назначьте одну или несколько ролей, ограниченных платформой или агентством.' },
        { title: 'Активация / деактивация', desc: 'Отключите доступ без удаления истории, когда кто-то уходит.' },
        { title: 'Учёт области видимости', desc: 'Администраторы управляют всеми пользователями; администратор агентства управляет только своими людьми.' },
      ],
    },
    related: ['rbac', 'settings'],
  },

  settings: {
    title: 'Настройки',
    tag: 'Конфигурация',
    tagline: 'Конфигурация уровня платформы и агентства в одном месте.',
    business: {
      lead: 'Настройки содержат рычаги, которые задают, как платформа выглядит и ведёт себя: брендинг, уведомления, интеграции и конфигурацию по умолчанию. Правильная их настройка сохраняет опыт согласованным, а инфраструктуру — подключённой.',
      points: [
        { title: 'Идентичность и опыт', desc: 'Брендинг и значения по умолчанию задают, как консоль выглядит и ведёт себя для ваших пользователей.' },
        { title: 'Оставайтесь на связи', desc: 'Настройки интеграций и уведомлений держат платформу в диалоге с внешним миром.' },
        { title: 'Ограниченное владение', desc: 'Администраторы платформы управляют общеплатформенными настройками; администраторы агентства управляют своей областью.' },
      ],
    },
    software: {
      lead: 'Сгруппированные панели конфигурации для брендинга, уведомлений, интеграций и значений по умолчанию агентства.',
      points: [
        { title: 'Редактируйте по разделам', desc: 'Пройдите по сгруппированным панелям и сохраните области, которыми вы управляете.' },
        { title: 'Ограничено разрешением', desc: 'Доступ требует разрешения на управление настройками; запись в боковой панели остаётся согласованной с остальной частью раздела «Система».' },
        { title: 'Платформа против агентства', desc: 'Что вы можете изменить, зависит от того, обладаете ли вы областью платформы или агентства.' },
      ],
    },
    related: ['rbac', 'users'],
  },

  issues: {
    title: 'Трекер проблем',
    tag: 'Внутренний QA',
    tagline: 'Внутренний трекер дефектов для регистрации и сортировки проблем продукта.',
    business: {
      lead: 'Трекер проблем — это то, как найденные в консоли проблемы фиксируются, сортируются и исправляются — приватная петля обратной связи для разработки, отдельная от тикетов поддержки клиентов, так что качество улучшается без шума, доходящего до агентств.',
      points: [
        { title: 'Замкните петлю', desc: 'Структурированный отчёт с контекстом превращает «оно сломано» в нечто, с чем инженер может работать.' },
        { title: 'Не поддержка клиентов', desc: 'Это внутренний QA — отличный от обращённых к агентствам тикетов поддержки.' },
        { title: 'С приложенными доказательствами', desc: 'Скриншоты и контекст среды делают проблемы воспроизводимыми.' },
      ],
    },
    software: {
      lead: 'Сортировочная очередь зарегистрированных проблем со снимками и статусом.',
      points: [
        { title: 'Регистрируйте где угодно', desc: 'Зафиксируйте проблему (со снимком) откуда угодно через горячую клавишу репортера, затем отслеживайте её здесь.' },
        { title: 'Сортировка и статус', desc: 'Работайте с очередью — назначайте, приоритизируйте и продвигайте проблемы по их жизненному циклу.' },
        { title: 'Ограничено разработчиком', desc: 'Полная сортировка ограничена ролью Разработчика, так что Трекер не загромождает вид каждого администратора.' },
      ],
    },
    related: ['my-issues'],
  },

  'my-issues': {
    title: 'Мои зарегистрированные проблемы',
    tag: 'Мои отчёты',
    tagline: 'Проблемы, которые вы подняли лично, и где находится каждая из них.',
    business: {
      lead: 'Это ваш собственный срез Трекера проблем — отчёты, которые вы подали, и их прогресс. Это замыкает петлю обратной связи для репортера: вы можете видеть, что то, что вы подняли, было увидено и движется.',
      points: [
        { title: 'Видимость для репортеров', desc: 'Знание, что отчёт получен и продвигается, побуждает людей продолжать сигнализировать о проблемах.' },
        { title: 'Ваш контекст', desc: 'Только проблемы, которые подняли вы, так что список остаётся лично релевантным.' },
        { title: 'Следите до решения', desc: 'Отслеживайте каждый отчёт от открытия до решения.' },
      ],
    },
    software: {
      lead: 'Отфильтрованный вид Трекера проблем, ограниченный вашими собственными отчётами.',
      points: [
        { title: 'Смотрите свои отчёты', desc: 'Каждая проблема, которую вы подали, с её текущим статусом.' },
        { title: 'Открывайте для деталей', desc: 'Углубитесь в отчёт, чтобы увидеть его тред, снимок и обновления.' },
        { title: 'Поднимайте ещё', desc: 'Подавайте новые проблемы через горячую клавишу репортера; они появляются здесь.' },
      ],
    },
    related: ['issues'],
  },

  'supply-properties': {
    title: 'Гостиничные объекты',
    tag: 'Собственный инвентарь',
    tagline: 'Ваш каталог напрямую законтрактованных отелей — номера, которыми вы владеете и которые продаёте сами.',
    business: {
      lead: 'Это отели, которые вы контрактуете напрямую, в отличие от тарифов, которые вы перепродаёте из внешних гостиничных движков. Поскольку инвентарь ваш, вы задаёте номера, посуточные тарифы и наличие — и вы удерживаете всю маржу вместо маржи бедбанка.',
      points: [
        { title: 'Собственный против перепродаваемого инвентаря', desc: 'Собственные объекты стоят рядом с результатами внешних гостиничных движков в «Поиске и бронировании»; здесь вы контролируете цену и наличие от начала до конца.' },
        { title: 'Область видимости решает охват', desc: 'Объект с областью платформы становится общим инвентарём, который может продавать любое агентство; объект с областью агентства остаётся приватным для этого агентства.' },
        { title: 'Режим продажи с первого взгляда', desc: 'Каждый объект — либо Мгновенный (подтверждает сразу), либо По запросу (бронирование, которое подтверждает оператор) — карточка отмечает, какой именно.' },
      ],
    },
    software: {
      lead: 'Сетка ваших объектов с возможностью поиска и фильтрации и быстрым статусом.',
      points: [
        { title: 'Найдите объект', desc: 'Ищите по названию или городу и фильтруйте по области видимости, режиму продажи или статусу.' },
        { title: 'Подключите новый', desc: 'Создайте с нуля или засейте из справочного отеля через панель подключения.' },
        { title: 'Откройте для управления', desc: 'Перейдите к записи объекта, чтобы управлять его номерами, тарифами, квотой, доп. услугами и договором.' },
      ],
    },
    related: ['supply-property-detail', 'reference-data'],
  },

  'supply-property-detail': {
    title: 'Гостиничный объект',
    tag: 'Запись объекта',
    tagline: 'Полная запись одного объекта — номера, тарифы, наличие, дополнения и договор за ними.',
    business: {
      lead: 'Гостиничный объект — это часть инвентаря, которой вы владеете и которую продаёте напрямую. Всё, что нужно бронированию, живёт здесь: какие номера существуют, сколько они стоят каждую ночь, сколько их доступно, какие дополнения можно добавить и договор, который этим управляет. Сделайте это правильно — и объект готов к продаже как в вашей B2B-консоли, так и в B2C.',
      points: [
        { title: 'Собственный инвентарь, ваша маржа', desc: 'Прямой договор, который вы загружаете сами, не несёт наценки бедбанка — разница между нетто и ценой продажи целиком ваша.' },
        { title: 'Область платформы против агентства', desc: 'Область платформы публикует объект как общий инвентарь для агентств; область агентства держит его приватным. Строки, принадлежащие платформе, доступны агентству только на чтение.' },
        { title: 'Мгновенный против По запросу', desc: 'Мгновенный подтверждает сразу против квоты; По запросу фиксирует бронирование как запрос, который оператор подтверждает или отклоняет в рамках SLA (платёж авторизуется, списывается при подтверждении).' },
        { title: 'Наличие защищает вас', desc: 'Квота — это законтрактованное количество номеров; удержания и проданные номера вычитаются, так что Мгновенная продажа никогда не может перепродать.' },
      ],
    },
    software: {
      lead: 'Рабочее пространство с вкладками для одного объекта — каждая вкладка это раздел записи с бейджем, показывающим, сколько она содержит. Ниже — что делает каждая вкладка и как работают её элементы.',
      points: [
        { title: 'Обзор', desc: 'Сводка «сначала для чтения»: расположение и карта, звёздность, сеть, ключевые удобства, описание и живые KPI — заполняемость с начала месяца, ADR и RevPAR (всё рассчитывается против общего номерного инвентаря объекта).' },
        { title: 'Номера и типы номеров', desc: 'Добавляйте / редактируйте каждый тип номера: выберите стандартизированную категорию из справочника «Типы номеров» (именно это управляет сопоставлением поиска и каналов), отображаемое для гостя название и короткий код, максимальную вместимость, площадь в м² и общий физический инвентарь — последнее является делителем в заполняемости / RevPAR из «Обзора».' },
        { title: 'Кровати (по типу номера)', desc: 'Конфигурация кроватей — это компоновщик, а не свободный текст: строки количество × тип кровати из справочника «Типы кроватей» (например, «1 King + 1 диван-кровать»). Скомпонованная строка — это то, что показывается в результатах поиска и на ваучере, так что она остаётся согласованной везде.' },
        { title: 'Удобства (по номеру и объекту)', desc: 'Множественный выбор на основе справочника, сгруппированный по категории удобств (управляется в «Справочные данные → Удобства»). Выбирайте из контролируемого списка, а не набирайте свободный текст; выборы хранятся как отображаемые метки, так что они отрисовываются одинаково в B2B-консоли, на ваучере и в B2C.' },
        { title: 'Галерея', desc: 'Загружайте и упорядочивайте фотографии уровня объекта и уровня номера. Это изображения, которые агенты видят в «Поиске и бронировании», а гости — на ваучере; номер без фото откатывается к галерее объекта.' },
        { title: 'Тарифные планы', desc: 'Тарифный план — это продаваемый пакет: Только номер, B&B, Невозвратный и т. д. Каждый несёт свои цены и может переопределить режим продажи объекта (Мгновенный / По запросу). Цены календаря и поиска всегда по тарифному плану.' },
        { title: 'Тарифы и календарь', desc: 'Для каждого тарифного плана задайте нетто-цену на одну ночь, диапазон дат или целый сезон одним действием. Даты выходных и сезона несут визуальные подсказки (цветная плашка), а стоп-продажа закрывает дату без удаления её цены. Значение тарифа обязательно для сохранения — пустой набор отклоняется.' },
        { title: 'Квота и удержания', desc: 'Законтрактованное количество номеров, доступных в день. Сетка разбивает каждый день на удержано (забронировано, платёж ещё не списан), продано (подтверждено) и свободно для продажи; массово обновляйте количество по диапазону дат. Мгновенные продажи уменьшают его в реальном времени; По запросу не трогают его, пока оператор не подтвердит.' },
        { title: 'Дополнительные услуги', desc: 'Дополнения, которые продаёт этот объект — трансфер из аэропорта, завтрак, спа, поздний выезд — каждое из справочника «Типы дополнительных услуг» с ценой и базой начисления (за бронирование / за ночь / за пассажира). Они появляются как дополнения в «Начислениях» бронирования.' },
        { title: 'Живые бронирования', desc: 'Каждое бронирование по этому объекту. Для проживаний По запросу панель Подтвердить / Отклонить живёт здесь: Подтвердить списывает авторизованный платёж и фиксирует квоту; Отклонить аннулирует авторизацию — оба в рамках окна SLA объекта.' },
        { title: 'Договор и настройки', desc: 'Договор с поставщиком плюс операционные переключатели: режим продажи (Мгновенный или По запросу с его часами SLA и днями отсечки бронирования), область платформы против агентства и активный статус объекта.' },
        { title: 'Подключение, редактирование и массовые инструменты', desc: 'Направляющая панель подключения создаёт объект с нуля или засеянным из справочного отеля; панель редактирования корректирует основные детали позже; а массовые панели задают тарифы или квоту на много дней сразу.' },
      ],
    },
    modes: {
      lead: 'Два переключателя меняют поведение объекта — режим продажи (задаётся в «Договоре и настройках», переопределяем по тарифному плану) и область видимости (задаётся при создании объекта).',
      modes: [
        { name: 'Instant', when: 'живая квота, которой вы доверяете', desc: 'Бронирование подтверждается сразу и уменьшает квоту; платёж списывается сразу. Оно блокируется, когда нет свободного номера на даты и вместимость.' },
        { name: 'On-Request', when: 'отель должен подтвердить', desc: 'Бронирование принимается как запрос — платёж авторизуется (не списывается), а квота не трогается — и оператор подтверждает или отклоняет в рамках SLA. Подтвердить списывает платёж и фиксирует квоту; отклонить аннулирует авторизацию.' },
        { name: 'Область платформы', when: 'общий инвентарь', desc: 'Объект публикуется агентствам как продаваемый инвентарь; они видят его только на чтение и перепродают под своей розничной наценкой.' },
        { name: 'Область агентства', when: 'приватный инвентарь', desc: 'Объект принадлежит одному агентству и продаётся только им.' },
      ],
    },
    examples: [
      {
        title: 'Наличие на ночь (режим продажи Instant)',
        rows: [
          { label: 'Законтрактованная квота', value: '10' },
          { label: '− В удержании (ожидает списания)', value: '3', accent: 'info' },
          { label: '− Продано (подтверждено)', value: '5' },
          { label: 'Свободно для продажи', value: '2', strong: true, accent: 'accent' },
        ],
        note: 'Бронирования По запросу не потребляют квоту, пока оператор не подтвердит — они ограничены типом номера, а не дневным количеством.',
      },
      {
        title: 'Тарифы и календарь — проживание 3 ночи (Deluxe · B&B)',
        rows: [
          { label: 'Чт 2 апр · будний нетто', value: '2,200,000' },
          { label: 'Пт 3 апр · выходной нетто', value: '2,600,000', accent: 'info' },
          { label: 'Сб 4 апр · выходной нетто', value: '2,600,000', accent: 'info' },
          { label: 'Подытог по номеру (3 ночи)', value: '7,400,000', strong: true },
        ],
        note: 'Каждая ночь несёт нетто-цену, заданную для её тарифного плана; подсказки выходных/сезона — визуальные вспомогательные средства, цена — та, что вы задали на эту дату. Ночь со стоп-продажей будет незабронируемой независимо от цены.',
      },
      {
        title: 'Дополнительные услуги по этому бронированию (2 гостя, 3 ночи)',
        rows: [
          { label: 'Подытог по номеру', value: '7,400,000' },
          { label: '+ Завтрак · за пассажира / ночь · 150,000 × 2 × 3', value: '+900,000', accent: 'success' },
          { label: '+ Трансфер из аэропорта · за бронирование', value: '+1,200,000', accent: 'success' },
          { label: 'Итого по объекту (до наценки)', value: '9,500,000', strong: true, accent: 'accent' },
        ],
        note: 'База начисления каждой доп. услуги (за бронирование / за ночь / за пассажира) решает, как она умножается. Розничная наценка из «Наценки и правила» затем применяется сверху, чтобы достичь цены для путешественника.',
      },
    ],
    tabs: {
      overview: {
        title: 'Обзор',
        lead: 'Снимок объекта «сначала для чтения» — где он, что предлагает и как работает прямо сейчас.',
        points: [
          { title: 'Идентичность и расположение', desc: 'Название, звёздность, сеть, адрес и метка на карте — факты, которые бронирующий проверяет первыми.' },
          { title: 'Ключевые удобства и описание', desc: 'Преимущества объекта, взятые из удобств на основе справочника и свободного описания.' },
          { title: 'Живые KPI', desc: 'Заполняемость с начала месяца, ADR (средний суточный тариф) и RevPAR (доход на доступный номер) — всё рассчитывается против общего номерного инвентаря объекта, так что они читаются верно только после того, как у каждого типа номера задан счётчик инвентаря.' },
        ],
        examples: [
          {
            title: 'Как рассчитываются KPI — 40 номеров, месяц из 30 дней',
            rows: [
              { label: 'Доступные номера-ночи (40 × 30)', value: '1,200' },
              { label: 'Проданные номера-ночи', value: '900' },
              { label: 'Заполняемость с начала месяца (900 ÷ 1,200)', value: '75%', accent: 'info', strong: true },
              { label: 'Доход по номерам', value: '90,000,000' },
              { label: 'ADR (доход ÷ продано 900)', value: '100,000' },
              { label: 'RevPAR (доход ÷ доступно 1,200)', value: '75,000', accent: 'success', strong: true },
            ],
            note: 'RevPAR смешивает цену и заполняемость, так что он падает, если проседает либо тариф, либо коэффициент заполнения. Отсутствие счётчика инвентаря типа номера ломает делитель — плитки показывают тире, пока он не задан на вкладке «Номера».',
          },
        ],
      },
      rooms: {
        title: 'Номера и типы номеров',
        lead: 'Определите, что объект может продавать: каждый тип номера, как он размещает и сколько его существует.',
        points: [
          { title: 'Нормализованная категория', desc: 'Выберите стандартизированный тип из справочника «Типы номеров» — именно это управляет сопоставлением поиска и каналов, а не название свободным текстом.' },
          { title: 'Отображаемое название и код', desc: 'Обращённое к гостю название («Deluxe с видом на море») и короткий код для оператора.' },
          { title: 'Кровати — компоновщик, а не свободный текст', desc: 'Постройте конфигурацию кроватей из строк количество × тип кровати (например, «1 King + 1 диван-кровать») из справочника «Типы кроватей»; скомпонованная строка — это то, что показывается в поиске и на ваучере.' },
          { title: 'Удобства', desc: 'Множественный выбор на основе справочника, сгруппированный по категории — хранится как отображаемые метки, так что они отрисовываются одинаково в B2B, на ваучере и в B2C.' },
          { title: 'Общий инвентарь', desc: 'Физическое количество номеров этого типа — делитель за заполняемостью и RevPAR из «Обзора», так что он должен быть задан, чтобы KPI читались верно.' },
        ],
      },
      gallery: {
        title: 'Галерея',
        lead: 'Фотографии, которые агенты видят в «Поиске и бронировании», а гости — на ваучере.',
        points: [
          { title: 'Фото объекта и номера', desc: 'Загружайте на уровне объекта и по типу номера; упорядочивайте их так, чтобы сильнейшее изображение шло первым.' },
          { title: 'Разумный откат', desc: 'Тип номера без собственного фото откатывается к галерее объекта, так что листинг никогда не остаётся без изображения.' },
        ],
      },
      rates: {
        title: 'Тарифы и календарь',
        lead: 'Задайте нетто-цену для каждого тарифного плана, по одной ночи или целому сезону за раз.',
        points: [
          { title: 'Тарифный план — это пакет', desc: 'Только номер, B&B, Невозвратный… каждый несёт свои цены и может переопределить режим продажи объекта. Цены поиска всегда по тарифному плану.' },
          { title: 'Один день · диапазон · сезон', desc: 'Устанавливайте цену на одну ночь, диапазон дат или целый сезон одним действием. Даты выходных и сезона несут цветную плашку, так что паттерн виден.' },
          { title: 'Стоп-продажа, не удаление', desc: 'Закрытие даты стоп-продажей сохраняет её цену на потом — значение тарифа обязательно для сохранения, так что пустой набор отклоняется.' },
        ],
        examples: [
          {
            title: 'От нетто-тарифа к цене, которую видит партнёр',
            rows: [
              { label: 'Нетто-тариф, который вы загружаете на ночь', value: '1,200,000' },
              { label: '+ Розничная наценка 8% (Наценка и правила)', value: '+96,000', accent: 'success' },
              { label: 'Цена поиска / продажи', value: '1,296,000', strong: true },
            ],
            note: 'Вы задаёте нетто здесь; цена продажи — это нетто плюс то, что добавляет ценовой слой Retail. Разница — ваша маржа на собственном инвентаре.',
          },
        ],
      },
      allotment: {
        title: 'Квота и удержания',
        lead: 'Законтрактованное количество номеров, доступных в день, и как каждый распределён.',
        points: [
          { title: 'Четыре состояния в день', desc: 'Квота — это законтрактованное количество; каждый день разбивается на удержано (забронировано, платёж ещё не списан), продано (подтверждено) и свободно для продажи.' },
          { title: 'Массовая установка', desc: 'Установите счётчик квоты на весь диапазон дат одним действием, так же как задаются тарифы.' },
          { title: 'Мгновенный против По запросу', desc: 'Мгновенные продажи уменьшают свободное для продажи в реальном времени, так что вы никогда не можете перепродать; продажи По запросу не трогают квоту, пока оператор не подтвердит.' },
        ],
        examples: [
          {
            title: 'Наличие одного дня',
            rows: [
              { label: 'Законтрактованная квота', value: '20' },
              { label: '− Удержано (ожидает списания)', value: '−3' },
              { label: '− Продано (подтверждено)', value: '−5' },
              { label: 'Свободно для продажи', value: '12', accent: 'success', strong: true },
            ],
            note: 'Мгновенное бронирование сразу переводит один номер из свободного → проданный; бронирование По запросу оставляет все четыре числа нетронутыми, пока оператор не подтвердит его на вкладке «Живые бронирования».',
          },
        ],
      },
      ancillaries: {
        title: 'Дополнительные услуги',
        lead: 'Дополнения, которые этот объект продаёт вместе с номером — трансферы, завтрак, спа, поздний выезд.',
        points: [
          { title: 'Из справочника', desc: 'Категория каждого дополнения берётся из справочника «Типы дополнительных услуг»; вы задаёте цену и базу начисления.' },
          { title: 'База начисления умножает', desc: 'За бронирование (однократно), за ночь (× ночи) или за пассажира (× гости) — база решает, как цена масштабируется на бронировании.' },
          { title: 'Появляется в «Начислениях»', desc: 'Добавленные дополнения появляются на вкладке «Начисления» бронирования и вливаются в цену для путешественника.' },
        ],
        examples: [
          {
            title: 'Дополнения на проживании 3 ночи, 2 гостя',
            rows: [
              { label: 'Трансфер из аэропорта · 450,000 за бронирование', value: '450,000' },
              { label: 'Завтрак · 250,000 за ночь × 3', value: '750,000' },
              { label: 'Итого дополнений, добавленных к бронированию', value: '1,200,000', accent: 'accent', strong: true },
            ],
            note: 'База начисления — это то, что заставляет одну и ту же прейскурантную цену масштабироваться по-разному: за бронирование берётся один раз, за ночь следует за длительностью проживания, за пассажира следует за числом гостей.',
          },
        ],
      },
      bookings: {
        title: 'Живые бронирования',
        lead: 'Каждое бронирование по этому объекту — и где подтверждаются проживания По запросу.',
        points: [
          { title: 'Полный список бронирований', desc: 'Смотрите, кто забронировал, какой номер и тарифный план, даты и статус.' },
          { title: 'Подтвердить / Отклонить По запросу', desc: 'Для проживаний По запросу панель решения живёт здесь: Подтвердить списывает авторизованный платёж и фиксирует квоту; Отклонить аннулирует авторизацию.' },
          { title: 'В рамках SLA', desc: 'Оба действия должны произойти в рамках окна SLA По запросу объекта (задаётся в «Договоре и настройках»), иначе запрос истекает.' },
        ],
      },
      settings: {
        title: 'Договор и настройки',
        lead: 'Договор с поставщиком плюс операционные переключатели, которые управляют тем, как объект продаётся.',
        points: [
          { title: 'Условия договора', desc: 'Коммерческое соглашение за объектом — основа для нетто-тарифов, которые вы загружаете.' },
          { title: 'Режим продажи', desc: 'Мгновенный или По запросу с его часами SLA и днями отсечки бронирования. Тарифные планы могут переопределить это по плану.' },
          { title: 'Область видимости и статус', desc: 'Платформа (общий доступ для агентств, только на чтение для них) против Агентства (приватный), плюс активный / приостановленный статус объекта.' },
        ],
      },
    },
    related: ['supply-properties', 'reference-data', 'markup'],
  },
};
